import { Alert as BootstrapAlert } from 'react-bootstrap';

const Alert = ({ variant, message }) => {
  if (!message) return null;
  return <BootstrapAlert variant={variant}>{message}</BootstrapAlert>;
};

export default Alert;